module.exports = __webpack_public_path__ + "img/google_chrome.51023d1b.svg";